module.exports = {
  locale: 'zh-CN',
  messages: {
    'app.header.lang': 'English',
    'app.header.home': '首页',
    'app.header.docs': '文档',
    'app.header.components': '组件',
    'app.content.quote': '使用方式',
    'app.content.demo': '代码演示',

    'app.home.docs': '文档',
    'app.home.components': '组件',
  },
};
